export const isArray = <T>(value: T | T[] | undefined | null): value is T[] =>
  Array.isArray(value);

type NonEmptyArray<T> = [T, ...T[]];

export const isPopulatedArray = <T>(
  value: T | T[] | ReadonlyArray<T> | undefined | null,
  length = 1,
): value is NonEmptyArray<T> | Readonly<NonEmptyArray<T>> =>
  Array.isArray(value) && value.length >= length && length > 0;

export type Unpacked<T> = T extends (infer U)[] ? U : T;
